import { WalletOverview } from '../../types'
import { MyWallet } from './MyWallet'
import { MyWalletChainMismatch } from './MyWalletChainMismatch'
import { assets } from '@/ui/assets'
import { ConnectOrSandboxCTAPanel } from '@/ui/organisms/connect-or-sandbox-cta-panel/ConnectOrSandboxCTAPanel'

interface MyWalletPanelProps {
  chainMismatch: boolean
  walletOverview: WalletOverview
  openConnectModal: () => void
  openSandboxModal: () => void
}

const icons = assets.walletIcons
const WALLET_ICONS_PATHS = [icons.metamask, icons.walletConnect, icons.coinbase, icons.enjin, icons.torus]

export function MyWalletPanel({
  walletOverview,
  openConnectModal,
  chainMismatch,
  openSandboxModal,
}: MyWalletPanelProps) {
  if (walletOverview.guestMode) {
    return (
      <ConnectOrSandboxCTAPanel
        header="Connect your wallet to use Spark"
        iconPaths={WALLET_ICONS_PATHS}
        action={openConnectModal}
        buttonText="Connect wallet"
        openSandboxModal={openSandboxModal}
      />
    )
  }

  if (chainMismatch) {
    return <MyWalletChainMismatch />
  }

  return (
    <MyWallet
      token={walletOverview.token}
      tokenBalance={walletOverview.tokenBalance}
      deposit={walletOverview.deposit}
      borrow={walletOverview.borrow}
    />
  )
}
